"use client";

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import CartIcon from '../cart/CartIcon';
import { useComingSoon } from '../../context/ComingSoonContext';

export default function MobileNavigation() {
  const pathname = usePathname();
  const { openPopup, hasSubmitted } = useComingSoon();
  
  const handleDiscountClick = () => {
    // Only track and open if not submitted
    if (!hasSubmitted) {
      // Track mobile discount button click
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'button_click', {
          'event_category': 'engagement',
          'event_label': 'Mobile Discount Button'
        });
      }
      openPopup();
    }
  };
  
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-lg z-50">
      <div className="flex justify-around items-center h-16">
        {/* Home */}
        <Link 
          href="/" 
          className={`flex flex-col items-center justify-center w-full h-full ${
            pathname === '/' ? 'text-primary' : 'text-gray-500'
          } active:bg-gray-50 transition-colors`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={pathname === '/' ? 2.5 : 2} strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
          <span className={`text-xs mt-1 ${pathname === '/' ? 'font-medium' : ''}`}>Home</span>
        </Link>
        
        {/* Discount Button or Coming Soon text */}
        <div
          className={`flex flex-col items-center justify-center w-full h-full ${hasSubmitted ? 'text-gray-500' : 'text-primary'} active:bg-gray-50 transition-colors`}
          onClick={handleDiscountClick}
        >
          {hasSubmitted ? (
            <>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-xs mt-1">Coming Soon</span>
            </>
          ) : (
            <>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
              </svg>
              <span className="text-xs mt-1 font-medium">Discount</span>
            </>
          )}
        </div>
        
        {/* Cart */}
        <Link 
          href="/checkout" 
          className={`flex flex-col items-center justify-center w-full h-full ${
            pathname === '/checkout' ? 'text-primary' : 'text-gray-500'
          } active:bg-gray-50 transition-colors`}
        >
          <div className="relative flex items-center justify-center">
            <CartIcon />
          </div>
          <span className={`text-xs mt-1 ${pathname === '/checkout' ? 'font-medium' : ''}`}>Cart</span>
        </Link>
        
        {/* Orders */}
        <Link 
          href="/orders" 
          className={`flex flex-col items-center justify-center w-full h-full ${
            pathname.startsWith('/orders') ? 'text-primary' : 'text-gray-500'
          } active:bg-gray-50 transition-colors`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={pathname.startsWith('/orders') ? 2.5 : 2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
          </svg>
          <span className={`text-xs mt-1 ${pathname.startsWith('/orders') ? 'font-medium' : ''}`}>Orders</span>
        </Link>
        
        {/* Profile/Account */}
        <Link 
          href="/account/profile" 
          className={`flex flex-col items-center justify-center w-full h-full ${
            pathname.startsWith('/account') ? 'text-primary' : 'text-gray-500'
          } active:bg-gray-50 transition-colors`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={pathname.startsWith('/account') ? 2.5 : 2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <span className={`text-xs mt-1 ${pathname.startsWith('/account') ? 'font-medium' : ''}`}>Account</span>
        </Link>
      </div>
    </div>
  );
} 